import { getHeaders, makeRequest } from "$utils/utils";
import config from "./config";

const url = config.api_url;

const getCompanyLastFile = async (token: string, companyId: string) => {
  const params = companyId ? `?company=${companyId}` : "";
  return makeRequest(
    `${url}/api/file${params}`,
    "GET",
    undefined,
    getHeaders(token)
  );
};

export default getCompanyLastFile;
